// © Microsoft Corporation. All rights reserved.

import {
    SearchBoxHandledProps as BaseComponentHandledProps,
    SearchBoxProps as BaseComponentProps,
    SearchBoxUnhandledProps,
    SearchFormParameters,
    SearchBoxManagedClasses
} from "./SearchBox.props";

import { SearchBox as BaseComponent, searchBoxId } from "./SearchBox";
import { SearchBoxStyles } from "./SearchBox.styles";
import manageJss, { ManagedJSSProps } from "@microsoft/fast-jss-manager-react";
import { Subtract } from "utility-types";
import { DesignSystem } from "@microsoft/fast-components-styles-msft";

/*
 * The type returned by manageJss type is very complicated so we'll let the
 * compiler infer the type instead of re-declaring just for the package export
 */
const SearchBox = manageJss(SearchBoxStyles)(BaseComponent);
type SearchBox = InstanceType<typeof SearchBox>;

// Create a valid JSS managed interface that doesn't require managed classes which are provided by the manageJSS HOC
type SearchBoxHandledProps = Subtract<BaseComponentHandledProps, SearchBoxManagedClasses>;

type SearchBoxProps = ManagedJSSProps<
BaseComponentProps,
SearchBoxManagedClasses,
DesignSystem
>;

export {
    SearchBox,
    SearchBoxProps,
    SearchBoxHandledProps,
    SearchBoxUnhandledProps,
    SearchFormParameters,
    searchBoxId
};